/**
 * FKX Logo angry easter egg
 * 3 clicks within 2s → anger mark + micro shake → auto clear ~2.5s
 *
 * Hardened for AJAX nav / Theme Editor / section reload:
 * - Installs at most ONE document capture listener (AbortController).
 * - Idempotent init on ajax:loaded + shopify:section:load.
 * - destroy() clears listener + all timers (no leaks).
 * - When config.enabled !== true: no listener, no timers (script ideally not loaded).
 */
(function () {
  'use strict';

  var CLICK_WINDOW_MS = 2000;
  var ANGRY_MS = 2500;
  var CLICKS_NEEDED = 3;

  var existing = window.__fkxLogoEaster;
  if (existing && typeof existing.destroy === 'function') {
    // Already installed for this document lifetime — never double-bind.
    return;
  }

  /** @type {WeakMap<Element, {clicks:number, timer:number|null, clearTimer:number|null}>} */
  var state = new WeakMap();
  /** @type {Set<number>} */
  var liveTimers = new Set();
  /** @type {AbortController|null} */
  var controller = null;
  var installed = false;

  function isEnabled() {
    var cfg = window.fkxLogoEasterConfig;
    return !!(cfg && cfg.enabled === true);
  }

  function trackTimeout(fn, ms) {
    var id = window.setTimeout(function () {
      liveTimers.delete(id);
      fn();
    }, ms);
    liveTimers.add(id);
    return id;
  }

  function clearTracked(id) {
    if (id == null) return;
    window.clearTimeout(id);
    liveTimers.delete(id);
  }

  function clearAllTimers() {
    liveTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    liveTimers.clear();
  }

  function getState(wrap) {
    var s = state.get(wrap);
    if (!s) {
      s = { clicks: 0, timer: null, clearTimer: null, isPlaying: false };
      state.set(wrap, s);
    }
    return s;
  }

  function clearClickWindow(s) {
    clearTracked(s.timer);
    s.timer = null;
    s.clicks = 0;
  }

  function triggerAngry(wrap) {
    var s = getState(wrap);
    if (s.isPlaying) return;

    clearClickWindow(s);
    clearTracked(s.clearTimer);
    s.clearTimer = null;
    s.isPlaying = true;

    wrap.classList.add('is-angry');

    s.clearTimer = trackTimeout(function () {
      wrap.classList.remove('is-angry');
      s.clearTimer = null;
      s.isPlaying = false;
      s.clicks = 0;
    }, ANGRY_MS);
  }

  function onClick(event) {
    if (!installed) return;
    if (event.defaultPrevented) return;
    if (event.button != null && event.button !== 0) return;

    var wrap =
      event.target && event.target.closest
        ? event.target.closest('.fkx-logo-wrap')
        : null;
    if (!wrap || !wrap.querySelector('.fkx-logo-anger')) return;

    var s = getState(wrap);
    // Spam protection: ignore all clicks while animation is running
    if (s.isPlaying) return;

    s.clicks += 1;

    clearTracked(s.timer);
    s.timer = trackTimeout(function () {
      clearClickWindow(s);
    }, CLICK_WINDOW_MS);

    if (s.clicks < CLICKS_NEEDED) return;

    event.preventDefault();
    event.stopPropagation();
    triggerAngry(wrap);
  }

  function destroy() {
    if (controller) {
      controller.abort();
      controller = null;
    }
    clearAllTimers();
    installed = false;
    document.querySelectorAll('.fkx-logo-wrap.is-angry').forEach(function (el) {
      el.classList.remove('is-angry');
      var s = state.get(el);
      if (s) {
        s.isPlaying = false;
        s.clicks = 0;
        s.timer = null;
        s.clearTimer = null;
      }
    });
  }

  function install() {
    if (!isEnabled()) {
      destroy();
      return;
    }
    if (installed && controller && !controller.signal.aborted) {
      return;
    }

    destroy();
    controller = new AbortController();
    document.addEventListener('click', onClick, {
      capture: true,
      signal: controller.signal,
    });
    installed = true;
  }

  window.__fkxLogoEaster = {
    destroy: destroy,
    install: install,
    isInstalled: function () {
      return installed && !!controller && !controller.signal.aborted;
    },
    /** Diagnostic: always 0 or 1 */
    listenerCount: function () {
      return this.isInstalled() ? 1 : 0;
    },
  };

  install();

  // Re-assert single install after SPA/AJAX + Theme Editor section lifecycle.
  // Must NOT add another click listener — install() is idempotent.
  document.addEventListener('ajax:loaded', install);
  document.addEventListener('shopify:section:load', install);
  document.addEventListener('shopify:section:unload', function () {
    // Header may be replaced in TE; keep document listener, just clear timers/state UI.
    clearAllTimers();
    document.querySelectorAll('.fkx-logo-wrap.is-angry').forEach(function (el) {
      el.classList.remove('is-angry');
    });
  });
})();
